import React from 'react'

import useBeforeunload from 'hooks/useBeforeunload'

import ContractContext from 'contexts/ContractContext'
import CollapseProvider from 'providers/CollapseProvider'

const ContractProvider = ({ children }) => {
  const defaultContract = {
    customer: null,
    contract: {
      urlNotification: '',
      dayExpiration: '',
      payment: 'prepaid',
      settings: {
        generateServiceTaxInvoices: false,
        daysToOverdueInvoice: '',
      },
      taxes: [],
      contractPlans: [],
      contractEmails: [],
    },
  }

  useBeforeunload(() => {
    return 'Sair do site?'
  })

  const [activeStep, setActiveStep] = React.useState(0)
  const [data, setData] = React.useState(defaultContract)

  return (
    <ContractContext.Provider
      value={{
        defaultContract,
        activeStep,
        setActiveStep,
        data,
        setData,
      }}
    >
      <CollapseProvider>{children}</CollapseProvider>
    </ContractContext.Provider>
  )
}

export default ContractProvider
